import IMask from 'imask'

export const PHONE_MASK_PATTERN = '+0 000 000-00-00'
export const PHONE_PLACEHOLDER = '+7 999 123-45-67'
export const PHONE_DIGIT_LENGTH = 11
export const PHONE_FORMAT_LABEL = '+N NNN NNN-NN-NN'
export const PHONE_DEFAULT_COUNTRY_CODE = '7'
export const PHONE_DEFAULT_VALUE = '+7'

const PHONE_MASK_OPTIONS = {
  mask: PHONE_MASK_PATTERN,
  lazy: true,
  overwrite: true
}

function buildPhoneMask() {
  return IMask.createMask(PHONE_MASK_OPTIONS)
}

export function applyPhoneMaskValue(mask, value, { defaultPrefix = false } = {}) {
  const digits = extractPhoneDigits(value)

  if (digits) {
    mask.unmaskedValue = digits
    return mask.value
  }

  if (defaultPrefix) {
    mask.unmaskedValue = PHONE_DEFAULT_COUNTRY_CODE
    return mask.value
  }

  mask.value = ''
  return ''
}

export function extractPhoneDigits(value) {
  return String(value ?? '').replace(/\D/g, '').slice(0, PHONE_DIGIT_LENGTH)
}

export function formatPhoneInput(value, { defaultPrefix = false } = {}) {
  const mask = buildPhoneMask()
  return applyPhoneMaskValue(mask, value, { defaultPrefix })
}

export function toPhoneSubmitValue(value) {
  const digits = extractPhoneDigits(value)
  return digits ? `+${digits}` : ''
}

export function validatePhoneInput(value, { required = false } = {}) {
  const digits = extractPhoneDigits(value)

  if (!digits.length) {
    return {
      valid: !required,
      digits: '',
      maskedValue: '',
      submitValue: '',
      message: required ? `Введите номер телефона в формате ${PHONE_FORMAT_LABEL}` : ''
    }
  }

  if (digits.length !== PHONE_DIGIT_LENGTH) {
    return {
      valid: false,
      digits,
      maskedValue: formatPhoneInput(digits),
      submitValue: '',
      message: `Введите полный номер телефона в формате ${PHONE_FORMAT_LABEL}`
    }
  }

  return {
    valid: true,
    digits,
    maskedValue: formatPhoneInput(digits),
    submitValue: toPhoneSubmitValue(digits),
    message: ''
  }
}

export function createPhoneMask(element) {
  const mask = IMask(element, PHONE_MASK_OPTIONS)
  applyPhoneMaskValue(mask, element.value)
  return mask
}